import styled from 'styled-components'

import { appZIndex } from '@/presentation/utils/zIndexMapper'

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${appZIndex.MODAL};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`

export const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${({ theme }) => theme.colors.secondaryD2};
  opacity: 0.6;
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  background: ${({ theme }) => theme.colors.secondaryD1};
  border-radius: 10px;
  overflow: clip;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 24px;
`

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const Title = styled.h3`
  ${({ theme }) => theme.fonts.titleMD};
  color: ${({ theme }) => theme.colors.neutralL5};
`

export const Description = styled.p`
  ${({ theme }) => theme.fonts.infoMD};
  color: ${({ theme }) => theme.colors.neutralL4};
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.secondaryL2};
`

export const FormModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 12px;
`
